import React, { useState, useRef, useEffect } from "react";
import { useGlobalValue } from "../../state/GlobalProvider";
import Icon from "../Icon/Icon";
import styles from "./Dropzone.module.sass";
import { UserRoles } from "../../utils/userRoles";
import { checkRoles } from "../../utils/roleValidator";
import FileUploaderStatus from "../inputs/FileUploader/FileUploaderStatus";
const Dropzone = props => {
  let maxFilesPerTicket = 5;
  const {
    setFiles,
    files
  } = props;
  const fileInput = useRef(null);
  const dropZone = useRef(null);
  const [dropActive, setDropActive] = useState(false);
  const [canAppendFiles, setCanAppendFiles] = useState(true);
  const [remainingFiles, setRemainingFiles] = useState(maxFilesPerTicket);
  const {
    i18n,
    params,
    reload,
    uploadFiles,
    user
  } = useGlobalValue();
  const appendFile = files => {
    uploadFiles && uploadFiles(params.projectId, []);
    setFiles(prevState => {
      const fileList = [...prevState];
      files.forEach(file => {
        if (fileList.findIndex(f => f.name === file.name) < 0) {
          fileList.push(file);
          setRemainingFiles(remainingFiles - files.length);
        }
      });
      return fileList.slice(0, 20);
    });
  };
  const handleChange = e => {
    e.preventDefault(e);
    const fileList = [...e.target.files];
    if (remainingFiles > 0 && fileList.length <= maxFilesPerTicket) {
      fileList && fileList.length && appendFile(fileList);
    } else {
      setCanAppendFiles(false);
      setTimeout(() => setCanAppendFiles(true), 3000);
    }
  };
  const dragChange = e => {
    if (e.type === "dragenter") {
      setDropActive(true);
    } else if ((e.pageX === 0 || e.pageY === 0) && (e.type === "dragleave" || e.type === "dragexit")) {
      setDropActive(false);
    } else if (e.type === "drop") {
      const inside = dropZone.current && dropZone.current.contains(e.target);
      const files = (e.dataTransfer || {
        files: []
      }).files;
      const fileList = [...files].filter(f => f.type === "text/txt" || f.type === "text/csv" || f.type === "text/xml" || f.type === "application/zip" || f.type === "text/plain" || f.type === "application/pdf" || f.type === "application/x-zip-compressed" || f.type === "image/png" || f.type === "image/jpeg" || f.type === "image/gif" || f.type === "image/jpg");
      if (inside && fileList && remainingFiles > 0 && fileList.length <= maxFilesPerTicket) {
        appendFile(fileList);
      } else {
        setCanAppendFiles(false);
        setTimeout(() => setCanAppendFiles(true), 3000);
      }
      setDropActive(false);
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  };
  useEffect(() => {
    document.body.addEventListener("dragover", dragChange);
    document.body.addEventListener("dragenter", dragChange);
    document.body.addEventListener("dragleave", dragChange);
    document.body.addEventListener("dragexit", dragChange);
    document.body.addEventListener("dragstart", dragChange);
    document.body.addEventListener("drop", dragChange);
    return () => {
      document.body.removeEventListener("dragover", dragChange);
      document.body.removeEventListener("dragenter", dragChange);
      document.body.removeEventListener("dragleave", dragChange);
      document.body.removeEventListener("dragexit", dragChange);
      document.body.removeEventListener("dragstart", dragChange);
      document.body.removeEventListener("drop", dragChange);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles["root"]
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles["content"]} ${dropActive ? styles["drop-active"] : ""}`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    ref: dropZone,
    className: styles["drop-zone"]
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    name: "upload"
  })), /*#__PURE__*/React.createElement("input", {
    ref: fileInput,
    className: styles["file-input"],
    type: "file",
    accept: "text/xml,application/*,text/plain,application/pdf,application/zip,image/*",
    multiple: true,
    onChange: handleChange
  }), checkRoles(user, [UserRoles.ADMIN, UserRoles.OWNER, UserRoles.WRITER, UserRoles.PP_SUPPORT, UserRoles.SUPPORT]) ? canAppendFiles ? /*#__PURE__*/React.createElement("div", null, files.length <= maxFilesPerTicket ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, i18n`Drop your files here or`, " "), /*#__PURE__*/React.createElement("button", {
    className: styles["input-button"],
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      if (fileInput.current) {
        fileInput.current.value = "";
        fileInput.current.click();
      }
    }
  }, /*#__PURE__*/React.createElement("strong", null, i18n`choose files`))) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", {
    className: styles["text-bold"]
  }, remainingFiles < maxFilesPerTicket ? remainingFiles === 0 ? i18n`Can't upload more files` : i18n`${remainingFiles} files remaining to upload` : i18n`Maximum ${maxFilesPerTicket} files or 20MB`, " "))) : /*#__PURE__*/React.createElement("small", {
    className: styles["text-bold"]
  }, i18n`You can't submit more than ${maxFilesPerTicket} files!`) : /*#__PURE__*/React.createElement("small", null, i18n`You dont have permissions to upload files`, " "))), /*#__PURE__*/React.createElement(FileUploaderStatus, {
    files: files,
    setFiles: setFiles,
    reload: reload,
    setRemainingFiles: setRemainingFiles,
    remainingFiles: remainingFiles,
    component: "freshdesk"
  })));
};
export default Dropzone;